import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_CONTACT_GROUP } from './../../../const/icons';

import { COMP_BUTTON_CONTACT_GROUP } from './../../../const/components';

import { FIELD_CONTACT_GROUP_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const ContactGroup = (editor, options:any = {}) => {

  (FIELD_CONTACT_GROUP_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_CONTACT_GROUP,
    displayIcon: ICON_BUTTON_CONTACT_GROUP,
    model: {
      defaults: { ...Defaults,
        name: 'Contact Group',
        traits: [ ...Traits, FIELD_CONTACT_GROUP_SELECTOR]
      }
    }
  });
}